import $ from 'cash-dom'

const isProduction = window.Pura?.environment?.production

const replaceStagingLinks = () => {
  const replaceLinks = () => {
    const $links = $('a[href*="pura.com"]')

    $links.each(function () {
      const $link = $(this)
      const href = $link.attr('href')

      if (href) {
        const newHref = href.replaceAll(
          /https?:\/\/(www\.)?pura\.com/gi,
          'https://staging-pura-scents.myshopify.com'
        )
        $link.attr('href', newHref)
      }
    })
  }

  if (document.readyState === 'loading') {
    $(document).ready(replaceLinks)
  } else {
    replaceLinks()
  }

  setTimeout(replaceLinks, 1000)
}

if (!isProduction) {
  replaceStagingLinks()
}
